<template>
  <div class="menu-select-parent-tree-container">
    <div class="tree-search">
      <el-input placeholder="请输入菜单名称" prefix-icon="el-icon-search" v-model="filterText" clearable></el-input>
    </div>
    <div class="tree">
      <el-tree
        ref="tree"
        :data="copyData"
        :props="defaultProps"
        :check-strictly="true"
        :default-expanded-keys="[activeId]"
        :filter-node-method="filterNode"
        node-key="id"
        show-checkbox
        @check-change="handleCheckChange">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span :title="node.label" :class="getClass(data) && 'active-node'">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div class="operation">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
let disableIds = []
export default {
  name: 'menu-select-parent-tree',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      filterText: '',
      defaultProps: {
        label: 'name',
        children: 'children',
        disabled: (data, node) => {
          if (disableIds.length === 0) {
            disableIds.push(this.activeId)
          }
          // 判断当前节点的父节点id是在禁用id内
          if (node.level !== 1) {
            let parent = node.parent.data
            if (disableIds.indexOf(parent.id) !== -1) {
              disableIds.indexOf(data.id) === -1 && disableIds.push(data.id)
            }
          }
          return disableIds.indexOf(data.id) !== -1
        }
      },
      activeName: '',
      // 为了不印象原有数据
      copyData: []
    }
  },
  created () {
    let data = this.$_.cloneDeep(this.data).filter(f => !f.link)
    this.disposeData(data)
    this.copyData = data
  },
  methods: {
    handleCheckChange (data, checked) {
      // 每次勾选的时候，需要把上一次勾选的去掉
      if (checked) {
        // 获取当前勾选中的节点，包括当前节点
        let checkedNodes = this.$refs.tree.getCheckedNodes()
        // 排除当前节点
        checkedNodes = checkedNodes.filter(c => c.id !== data.id)
        if (checkedNodes && checkedNodes.length) {
          let node = this.getNode(checkedNodes[0].id)
          if (node) {
            node.checked = false
          }
        }
      }
    },
    save () {
      // 勾选的节点
      let checkedNodes = this.$refs.tree.getCheckedNodes()
      if (checkedNodes && checkedNodes.length) {
        // 当前节点
        this.$emit('save', checkedNodes[0])
      } else {
        this.cancel()
      }
    },
    cancel () {
      this.$emit('closeDialog')
    },
    getNode (param) {
      return this.$refs.tree.getNode(param)
    },
    // 节点过滤
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    disposeData (tree) {
      tree && tree.length && tree.forEach(c => {
        c.children = c.children.filter(f => !f.link)
        c.children && this.disposeData(c.children)
      })
    }
  },
  computed: {
    getClass () {
      return node => node.id === this.activeId
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  beforeDestroy () {
    // 如果在data中定义会导致渲染上的死循环，放在外面相当于是全局变量，需要清空
    disableIds = []
  }
}
</script>

<style lang="scss">
.menu-select-parent-tree-container {
  height: 567px;
  .tree-search {
    padding-bottom: 10px;
  }
  .tree {
    height: calc(100% - 95px);
    overflow: auto;
    .el-tree {
      .el-tree-node {
        .el-tree-node__content {
          height: 30px;
          line-height: 30px;
          .el-tree-node__expand-icon {
            font-size: 14px;
          }
          .el-tree-node__label {
            font-size: 12px;
          }
          .custom-tree-node {
            width: calc(100% - 20px);
            height: 24px;
            line-height: 24px;
            display: flex;
            align-items: center;
            user-select: none;
            & > span:first-child {
              display: inline-block;
              max-width: calc(100% - 50px);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-right: 10px;
            }
            .active-node {
              color: var(--primary, #54ABF1);
            }
          }
          .el-checkbox {
            span {
              color: #606266;
            }
            .el-checkbox__label {
              float: left;
              padding: 0 10px 0 0;
            }
          }
          .is-checked {
            .el-checkbox__input {
              .el-checkbox__inner {
                background-color: #fff;
                border-color: var(--primary, #55ACF1);
                color: #55ACF1;
                &::after {
                  border: 1px solid var(--primary, #55ACF1);
                  border-left: 0;
                  border-top: 0
                }
              }
            }
          }
        }
      }
      & > .el-tree-node {
        & > .el-tree-node__content {
          border-bottom: 1px solid #EDF2F5;
          height: 38px;
          line-height: 38px;
        }
      }
    }
  }
  .operation {
    text-align: center;
    padding-top: 15px;
    .el-button {
      width: 82px;
      height: 26px;
      border-radius: 3px;
      padding: 0;
    }
    .el-button + .el-button {
      margin-left: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system/menu/menu-select-parent-tree.vue